import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const LocCtx = createContext(null);
export const useLocationCtx = () => useContext(LocCtx);

const KEY = "kn_location";
const DEFAULT = { lat: 43.9096, lng: 12.9131, radius: 15, label: "Pesaro" };

export function LocationProvider({ children }) {
  const [loc, setLoc] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY));
      if (saved && saved.lat) return saved;
    } catch (_) {}
    return DEFAULT;
  });
  const [locating, setLocating] = useState(false);

  const persist = useCallback((next) => {
    setLoc(next);
    localStorage.setItem(KEY, JSON.stringify(next));
  }, []);

  const requestGeo = useCallback(() => {
    if (!navigator.geolocation) return;
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        persist({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          radius: loc.radius || 15,
          label: "La mia posizione",
        });
        setLocating(false);
      },
      () => setLocating(false),
      { enableHighAccuracy: true, timeout: 8000 }
    );
  }, [loc.radius, persist]);

  const setRadius = (r) => persist({ ...loc, radius: r });
  const setManual = (lat, lng, label) => persist({ ...loc, lat, lng, label: label || "Zona scelta" });

  return (
    <LocCtx.Provider value={{ loc, locating, requestGeo, setRadius, setManual }}>
      {children}
    </LocCtx.Provider>
  );
}
